module.exports = __webpack_public_path__ + "static/img/vouchers15.92be93ca.png";